import { render, staticRenderFns } from "./SimpleList.vue?vue&type=template&id=ad98123a&scoped=true"
import script from "./SimpleList.vue?vue&type=script&lang=js"
export * from "./SimpleList.vue?vue&type=script&lang=js"
import style0 from "./SimpleList.vue?vue&type=style&index=0&id=ad98123a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad98123a",
  null
  
)

export default component.exports